/*global validate */

var sfr = {
    init: function() {
        $(document).on('click', '.send-booking-url', function(e) {
            e.preventDefault();
            if (!$(this).hasClass('disabled')) {
                sfr.validate();
            }
        });

        $(document).on('submit', '#emailQuoteForm', function(e) {
            e.preventDefault();
        });
    },
    validate: function() {
        var sendBtn = $('.send-booking-url'),
            requiredFields = $('.required');

        sendBtn.addClass('disabled');

        $(requiredFields.get().reverse()).each(function() {
            validate.validate($(this));
        });

        if (!requiredFields.hasClass('error')) {
            $.postJSON(_d.url.offer.emailQuote, $('#emailQuoteForm').serialize(), function(response) {
                if (!response.error) {
                    $('.send-booking-url').css({'opacity': 0});
                    $('.email-quote-successfully').html(response.message);
                    $('.email-quote-successfully-box').addClass('show');

                    setTimeout(function() {
                        $('.modal-close').trigger('click');
                    }, 5000);
                } else {
                    $('.error-message').html(response.message).slideDown();
                    sendBtn.removeClass('disabled loading');
                }
            });

        } else {
            sendBtn.removeClass('disabled loading');
        }
    }
};
